<template>
    <div>
        <el-table :data="tableData" v-loading="loading">
            <el-table-column :label="type == 'group' ?  '组名称' : '姓名'" prop="name"></el-table-column>
            <el-table-column label="任务总数" prop="tasksTotal"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import services from "../../services/common.service";
    export default {
        props:{
            type:String,
            groupId:String,
            userId:String,
        },
        data() {
            return {
                tableData:[],
                loading:true,
            }
        },
        created() {
            this.type == 'group' ? this.getGroupBusyness() : this.getUserBusyness();
        },
        methods: {
            getUserBusyness(){
                services.busynessUser(this.userId).then(res => {
                    this.tableData = [res];
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            getGroupBusyness(){
                services.busynessGroup(this.groupId).then(res => {
                    this.tableData = [res];
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
